import React, { FC, useMemo, useState } from 'react'

import { Modal, Txt, Icon, Tooltip } from 'src/components/atoms'
import { ProjectsBulkAssign } from 'src/components/organisms'

import { ProfileEntity, UserEntity } from 'src/types'

type Props = {
  targetProjectIds: string[]
  profile: ProfileEntity
  isOpen: boolean
  onClose: () => void
  afterAssigned?: () => void
}

export const ProjectsBulkAssignModal: FC<Props> = ({
  targetProjectIds,
  profile,
  isOpen,
  onClose,
  afterAssigned,
}) => {
  const [selectedUsers, setSelectedUsers] = useState<UserEntity[]>([])

  const handleOnSelectAlreadyUser = (selectedUser: UserEntity) => {
    const updatedUsers = selectedUsers.filter(user => user.id !== selectedUser.id)
    setSelectedUsers(updatedUsers)
  }

  // TODO: 同じような処理が AssignUsersForCustomRoleModal.tsx にもあるので共通化する
  // ユーザーが表示されるdropdownがモーダルのコンテンツ外にはみ出しても良い場合はfalseを設定する必要がある
  // 基本はtrueを設定する事でコンテンツがはみ出さずキレイに表示される
  const enabledMainContentOverflow = useMemo(() => {
    // NOTE:
    //  もし人数による制限でUI崩れの対処に無理がある場合は要素の高さを計算して制限を行う必要がある
    //  大きく表示が崩れる事がないはずのため時間優先でマジックナンバーで対応

    // ある程度のユーザーがアサインされるとモーダル内のコンテンツの高さが高くなり、
    // overflowを調整しユーザー検索のdropdownがはみ出す設定が必要なくなる。
    // 逆にoverflowの設定を行わないと、モーダル内のコンテンツが意図せずはみ出してUIが崩れるため、ある程度の人数がアサインされた場合はtrueが返るようにする
    const EnabledOverflowAssignCount = 20
    return selectedUsers.length > EnabledOverflowAssignCount
  }, [selectedUsers.length])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      enabledMainContentOverflow={enabledMainContentOverflow}
      canCloseClickOuter={false}
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-full-justify">
            <div className="tw-flex tw-items-center">
              <Icon
                size="--r1"
                path="plus/soft/line"
                className="tw-accent-standardText-secondary"
              />
              <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
                ユーザーアサイン
              </Txt>
            </div>
            <Tooltip
              text="選択したプロジェクトへユーザーがまとめてアサインされます。"
              placement="top"
            >
              <div />
            </Tooltip>
          </div>
        </div>
      }
    >
      <div className="tw-w-[56.14rem] tw-p-s2">
        <ProjectsBulkAssign
          targetProjectIds={targetProjectIds}
          selectedUsers={selectedUsers}
          profile={profile}
          onCancel={onClose}
          selectUser={user => setSelectedUsers([...selectedUsers, user])}
          selectAlreadyUser={handleOnSelectAlreadyUser}
          afterAssigned={afterAssigned}
        />
      </div>
    </Modal>
  )
}
